function importAll(r) {
    return r.keys().map(r);
  }
  
  const audio = importAll(require.context('../assets/media/audio/', false, /\.(mp3)$/));

  export default audio

